import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { Check, Clock } from "@phosphor-icons/react";

export default function FollowUps() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("open");

  const load = () => api.get("/followups", { params: { filter } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [filter]);

  const complete = async (f) => { await api.put(`/followups/${f.id}`, { completed: !f.completed }); load(); };
  const remove = async (f) => { await api.delete(`/followups/${f.id}`); load(); };

  const today = new Date().toISOString().slice(0, 10);
  const groups = { overdue: [], today: [], week: [], later: [], done: [] };
  const weekEnd = new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10);
  items.forEach((f) => {
    const d = f.due_date.slice(0, 10);
    if (f.completed) groups.done.push(f);
    else if (d < today) groups.overdue.push(f);
    else if (d === today) groups.today.push(f);
    else if (d <= weekEnd) groups.week.push(f);
    else groups.later.push(f);
  });

  return (
    <div className="p-6 md:p-10" data-testid="followups-page">
      <Toaster theme="dark" />
      <div className="overline mb-2">// follow-ups</div>
      <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-8">Reminders &amp; rituals</h1>

      <div className="flex gap-2 mb-8">
        {["open", "all"].map((k) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`filter-${k}`}
            className="tag cursor-pointer" style={filter === k ? { borderColor: "var(--text)", color: "var(--text)" } : {}}>
            {k === "open" ? "Pending" : "All"}
          </button>
        ))}
      </div>

      {[
        { key: "overdue", label: "Overdue", accent: true },
        { key: "today", label: "Today" },
        { key: "week", label: "This week" },
        { key: "later", label: "Later" },
        ...(filter === "all" ? [{ key: "done", label: "Completed" }] : []),
      ].map((g) => (
        <section key={g.key} className="mb-10">
          <div className="overline mb-3" style={g.accent ? { color: "var(--accent)" } : {}}>// {g.label} · {groups[g.key].length}</div>
          {groups[g.key].length === 0 ? (
            <div className="border p-4 text-sm text-[#C7DDE5]" style={{ borderColor: "var(--border)" }}>Nothing here.</div>
          ) : (
            <div className="border" style={{ borderColor: "var(--border)" }}>
              {groups[g.key].map((f, i) => (
                <div key={f.id} data-testid={`followup-${f.id}`} className={`p-4 flex items-center justify-between gap-4 ${i > 0 ? "border-t" : ""}`} style={{ borderColor: "var(--border)" }}>
                  <button onClick={() => complete(f)} data-testid={`toggle-${f.id}`} className="w-8 h-8 flex items-center justify-center border" style={{ borderColor: "var(--border-2)" }}>
                    {f.completed && <Check weight="bold" />}
                  </button>
                  <div className="flex-1 min-w-0">
                    <Link to={`/contacts/${f.contact_id}`} className="font-semibold hover:underline">{f.contact?.name || "Contact"}</Link>
                    <div className="overline mt-1">{f.type} · {new Date(f.due_date).toLocaleString()}</div>
                    {f.notes && <div className="text-sm text-[#C7DDE5] mt-1 line-clamp-2">{f.notes}</div>}
                  </div>
                  <button onClick={() => remove(f)} className="overline hover:text-white" data-testid={`del-${f.id}`}>delete</button>
                </div>
              ))}
            </div>
          )}
        </section>
      ))}
    </div>
  );
}
